@import "../../../css/_mixins.scss";
.header {
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-wrap: wrap;
  gap: 32px;
  width: 100%;
  box-sizing: border-box;

  @include small-desktop {
    min-height: 240px;
    gap: 24px;
  }
  @include tablet {
    min-height: 190px;
    gap: 20px;
    justify-content: center;
  }
  @include mobile {
    min-height: 150px;
    gap: 16px;
  }

  .caption {
    font-size: 34px;
    font-weight: bold;
    line-height: 1.2;
    max-width: min(50vw, 460px);
    @include small-desktop {
      font-size: 30px;
    }
    @media screen and (max-width: 800px) {
      text-align: center;
      max-width: 92vw;
    }
    @include tablet {
      font-size: 28px;
    }
    @include mobile {
      font-size: 24px;
    }
  }

  .captionSmall {
    font-size: 22px;
    font-weight: bold;
    line-height: 1.25;
    max-width: min(50vw, 460px);

    @media screen and (max-width: 800px) {
      text-align: center;
      width: 100%;
      max-width: 92vw;
    }
    @include tablet {
      font-size: 20px;
    }
    @include mobile {
      font-size: 18px;
    }
  }

  .logoImg {
    height: auto;
    max-height: min(40vh, 500px);
    width: auto;
    max-width: min(50vw, 480px);

    @include tablet {
      max-height: min(32vh, 320px);
      max-width: 80vw;
    }
    @include mobile {
      max-height: min(26vh, 240px);
      max-width: 88vw;
    }
  }

  .lonelyLogoImg {
    height: auto;
    max-height: 56vh;
    width: auto;
    max-width: min(95vw, 100%);

    @include tablet {
      max-height: 42vh;
    }
    @include mobile {
      max-height: 34vh;
    }
  }
}
